module.exports = __webpack_public_path__ + "img/food-1.334ab788.jpg";